import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    IMilestoneActivityCard,
    IActivityDetail,
    IMilestone,
    IMiestoneActivityParams,
} from '../interfaces/pipeline-activity-data';

@Injectable({
    providedIn: 'root',
})
export class PipelineActivityService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/pipelineactivity').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getActivityCardsDataByMilestone(
        body: IMiestoneActivityParams
    ): Observable<IMilestoneActivityCard> {
        let head = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.http.post<IMilestoneActivityCard>(
            this._url + '/GetActivityCardsDataByMilestone',
            body,
            { headers: head }
        );
    }

    getActivityCardData(loanNumber: string): Observable<IActivityDetail> {
        return this.http.post<IActivityDetail>(this._url + '/GetPipelineActivityDetail', {
            loanNumber: loanNumber,
        });
    }

    getMilestones(displayViewBy: string): Observable<IMilestone[]> {
        const params = new HttpParams().set('displayViewBy', displayViewBy);
        return this.http.get<IMilestone[]>(this._url + '/GetMilestones', { params });
    }

    //
    // Loan Card
    //
    getLoanDetails(loanNumber: string): Observable<any> {
        return this.http.post<any>(this._url + '/loan/detail', {
            loanNumber: loanNumber,
        });
    }

    getLoanContacts(loanNumber: string): Observable<any[]> {
        return this.http.post<any[]>(this._url + '/loan/contacts', {
            loanNumber: loanNumber,
        });
    }

    getLoanMilestones(loanNumber: string): Observable<any[]> {
        return this.http.post<any[]>(this._url + '/loan/milestones', {
            loanNumber: loanNumber,
        });
    }

    getLoanTracking(loanNumber: string): Observable<any[]> {
        return this.http.post<any[]>(this._url + '/loan/tracking', {
            loanNumber: loanNumber,
        });
    }

    getLoanRisk(loanNumber: string): Observable<any[]> {
        return this.http.post<any[]>(this._url + '/loan/risk', {
            loanNumber: loanNumber,
        });
    }
}
